import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QRCodeSVG as QRCode } from 'qrcode.react';
import styles from './QRCode.module.less';
const HVQRCode = ({ displayValue, float, value }) => {
    return (_jsxs("div", { className: styles['wrapper'], style: { float: float || 'auto' }, children: [_jsx("div", { className: styles['qr-code'], children: _jsx(QRCode, { size: 168, value: value }) }), _jsx("p", { className: styles['display-value'], children: displayValue || 'Scan Me' })] }));
};
export default HVQRCode;
